// The SDK throws when a payload exceeds its character limit rather than
// truncating. Unguarded, that error reaches the nearest boundary and takes the
// whole page down, and callers that go on to send a message would lose it.
// Returns whether the agent accepted the payload.
export function pushSituationalAwareness(agentEl, context) {
  try {
    var _agentEl$setSituation;
    (_agentEl$setSituation = agentEl.setSituationalAwareness) === null || _agentEl$setSituation === void 0 || _agentEl$setSituation.call(agentEl, context);
    return true;
  } catch (e) {
    console.error('Mindset:', e);
    return false;
  }
}